import { LOCARI_PFAD, SCHNITT_PFAD } from '@kit/ui/wortmarke';

/**
 * Locari Wordmark – inline SVG, identisch zur chrome.js-Quelle (Cut-Out im "A").
 * variant="white" für den dunklen Footer-Hintergrund.
 *
 * ===========================================================================
 * 🔴 DER GLYPHPFAD STEHT NICHT MEHR HIER — Design-Anweisung 577 (20.09.2026)
 * ===========================================================================
 *
 * Hier standen `WORDMARK_PATH` und der Schnitt als eigene Konstanten, Zeichen
 * für Zeichen dieselben wie in `@kit/ui/wortmarke`. 577:
 *
 *   „Die schlechte [Nachricht]: zwölf Kopien sind zwölf Stellen, an denen ein
 *    Markenwechsel vergessen werden kann. […] Es gilt: Die SVG-Datei ist die
 *    einzige Quelle."
 *
 * Und 578 zeigt, was aus so einer Kopie wird: in einem Blatt war eine davon
 * verstümmelt („sie zeigte «loc» statt «locari»"), während daneben bescheinigt
 * stand, alle seien identisch.
 *
 * ⚠️ DIESE DATEI BLEIBT TROTZDEM EIGEN, und das ist Absicht. Sie rendert
 * anders als `<Wortmarke>`: 120×38 statt der drei App-Größen, `var(--primary)`
 * als Füllung statt `currentColor` über `text-primary`, eine eigene
 * Maskenkennung je Variante, dazu `role="img"` und `aria-label`. Das Marketing
 * hat seinen eigenen Namensraum; nur der PFAD ist beiden gemeinsam, und der
 * kommt jetzt von einer Stelle.
 *
 * 🔴 DER RENDER-AUSGANG ÄNDERT SICH NICHT. Beide Konstanten sind
 * zeichengleich mit denen, die hier standen — gegengeprüft am 20.09.2026 über
 * `diff`. DS-Regel 6 („eine Erweiterung darf den Render-Output bestehender
 * Flächen nicht ändern") ist damit gewahrt.
 */
export function Wordmark({
  variant = 'brand',
}: {
  variant?: 'brand' | 'white';
}) {
  const fill = variant === 'white' ? '#FFFFFF' : 'var(--primary)';
  return (
    <svg
      viewBox="-4 -4 326 104"
      width="120"
      height="38"
      role="img"
      aria-label="Locari"
      focusable="false"
    >
      <defs>
        <mask id={`locari-wm-cut-${variant}`}>
          <rect x="-4" y="-4" width="326" height="104" fill="#fff" />
          <path d={SCHNITT_PFAD} fill="#000" />
        </mask>
      </defs>
      <path
        d={LOCARI_PFAD}
        fill={fill}
        mask={`url(#locari-wm-cut-${variant})`}
      />
    </svg>
  );
}
